import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import darmLogo from './assets/icon/DARM-logo6.png'
import aiplanLogo from './assets/icon/AI_PLAN_LOGO_BG_2.png'
import toyotaLogo from './assets/icon/logo-toyota.png'
import * as generalUtils from './generalUtils'
import aiplanlogo1 from './assets/icon/logoaiplan/IPLAN-IPC-logo-bianco.png'
const root = ReactDOM.createRoot(document.getElementById('root'));

const profile = process.env.REACT_APP_PROFILE;
let logo;
let title = "";

if (profile === "AIPLAN") {
  logo = aiplanLogo;
  title = "AI PLAN";
  document.getElementById("brand-title").textContent = title;
  // Hide brand-title for AIPLAN profile
  document.getElementById("brand-title").style.display = "none";

} else if (profile === "TOYOTA") {
  logo = toyotaLogo;
  title = "Toyota";
} else {
  logo = aiplanlogo1;
  title = "";
}
// const logo = profile === "AIPLAN" ? aiplanLogo : darmLogo;
title = profile === "AIPLAN" ? "QA Automation" : "";

document.getElementById("logo-img").src = logo;

root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

